import React, { useEffect } from "react";
import GraphicUtils from "../../../../../utils/graphic-utils.js";

const BarsContent = ({data, elementId, title, elementLabels = 'label', elementValues = 'value', top = null, last = false, observation = null}) => {

    useEffect(() => {
        if (!data?.length) return;

        const labels = [];
        const values = [];

        data.forEach((element) => {
            labels.push(element[elementLabels]);
            values.push(element[elementValues] ?? 0);
        });

        GraphicUtils.barChart(elementId, top ? values.slice(0, top) : values, top ? labels.slice(0, top) : labels, false);
    }, [data, elementId, elementLabels, elementValues]);

    return (
        <>
            <div className="chart-report">
                <span className="chart-title">{title} {top && data?.length >= top ? ` (TOP ${top})` : ""}</span>
                { data?.length ? (
                    <div className="mt-1" id={elementId}></div>
                ) : (
                    <div id="noDataMessage" className={"alert alert-info p-2 h6 text-center"}>
                        Nenhum registro encontrado no período informado.
                    </div>
                )}
            </div>

            { data?.length && observation && (
                <span className="obs-warn">{observation}</span>
            )}

            { !last && (
                <div className="chart-divisor print:hidden"/>
            )}
        </>
    );
};

export default BarsContent;